import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutGrid } from 'lucide-react';
import './Home.css';

const formatDate = (date) =>
  new Intl.DateTimeFormat('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'long',
  }).format(date);

const formatTime = (date) =>
  new Intl.DateTimeFormat('zh-CN', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date);

function Home() {
  const navigate = useNavigate();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    // 每分钟刷新一次，并对齐到整分钟边界
    let timer;
    const schedule = () => {
      timer = window.setTimeout(() => {
        setNow(new Date());
        schedule();
      }, 60_000 - (Date.now() % 60_000) + 20);
    };
    schedule();
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <main className="home">
      <div className="home__veil" aria-hidden="true" />

      <section className="home__hero">
        <p className="home__date">{formatDate(now)}</p>
        <h1 className="home__time">
          <time dateTime={now.toISOString()}>{formatTime(now)}</time>
        </h1>
      </section>

      {/* IDLE 状态下桌面的唯一入口；进入桌面后立即消失 */}
      <button
        type="button"
        className="home__fab"
        onClick={() => navigate('/desktop')}
        aria-label="打开桌面"
      >
        <LayoutGrid size={20} strokeWidth={1.8} aria-hidden="true" />
      </button>
    </main>
  );
}

export default Home;
